import { render, staticRenderFns } from "./SelectContent.vue?vue&type=template&id=1f2f6585&"
import script from "./SelectContent.vue?vue&type=script&lang=js&"
export * from "./SelectContent.vue?vue&type=script&lang=js&"
import style0 from "./SelectContent.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports